import { Application } from "../config";
import { images } from "../images";
import { DocumentType } from "../models/document-type";
import { ICancelBookingReasons } from "../models/cancel-booking-reasons";
import { ISignInLanding } from "../models/sign-in-landing";

const { isNemi, isAmb, isIframe, isBeiraBaixa } = Application

const appsStyle = [
    { name: 'Nemi', style: 'nemi', selected: isNemi },
    { name: 'AMB', style: 'amb', selected: isAmb },
    { name: 'Iframe', style: 'iframe', selected: isIframe },
    { name: 'Beira Baixa', style: 'nemi', selected: isBeiraBaixa }
]

const appsGeneralInfo = [
    { name: 'Nemi', id: 'Nemi', title: 'Nemi Your digital partner', copyright: '© Nemi', selected: isNemi },
    { name: 'AMB', id: 'AMB', title: 'Àrea Metropolitana de Barcelona', copyright: '© Àrea Metropolitana de Barcelona', selected: isAmb },
    { name: 'Iframe', id: 'Iframe', title: 'Iframe', copyright: '© Iframe', selected: isIframe },
    { name: 'Beira Baixa', id: 'BeiraBaixa', title: 'Beira Baixa', copyright: '© CIM Beira Baixa', selected: isBeiraBaixa },
]

const appsURLS = [
    { name: 'Nemi', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', supportMail: 'support@nemi.mobi', selected: isNemi },
    { name: 'AMB', home: 'http://www.amb.cat/s/home.html', contact: 'http://www.amb.cat/web/amb/seu-electronica/suggeriments-i-queixes', linkedin: 'https://www.linkedin.com/cws/share?url=http://www.amb.cat/guia-estils', twitter: '', supportMail: 'support@nemi.mobi', selected: isAmb },
    { name: 'Iframe', home: 'http://nemi.mobi', contact: 'http://www.nemi.mobi/#contact', linkedin: 'https://es.linkedin.com/company/ne-mi', twitter: 'https://twitter.com/nemidrt', supportMail: 'support@nemi.mobi', selected: isIframe },
    { name: 'Beira Baixa', home: 'https://www.cimbeirabaixa.pt', contact: 'mailto:transportes@cimbeirabaixa.pt', linkedin: '', twitter: '', supportMail: 'transportes@cimbeirabaixa.pt', selected: isBeiraBaixa },
]

// logo: menu bar · logoRounded: auth screens · logoInformation: Configuration > Information,
// when the backend sends no client logo.
const appsLogos = [
    { name: 'Nemi', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], logoInformation: images['logoNemi'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isNemi },
    { name: 'AMB', logo: images['logoWhite'],logoRounded: images['logoAmb'], logoInformation: images['logoNemi'], alt: 'AMB:Bus Metropolità', class: 'logo', classRounded: 'logoAmb', selected: isAmb },
    { name: 'Iframe', logo: images['logoNemiOnlyN'], logoRounded: images['logoNemiRounded'], logoInformation: images['logoNemi'], alt: 'Nemi', class: 'logo nemi', classRounded: 'logoNemiRounded', selected: isIframe },
    { name: 'Beira Baixa', logo: images['logoBeiraBaixaRounded'], logoRounded: images['logoBeiraBaixaRounded'], logoInformation: images['logoBeiraBaixa'], alt: 'Beira Baixa', class: 'logo beirabaixa', classRounded: 'logoBeiraBaixaRounded', selected: isBeiraBaixa },
]

const appsPrivacyAndTermsOptions = [
    { name: 'Nemi', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'Nemi Mobility Solutions SL', someLanguages: true, selected: isNemi },
    { name: 'AMB', privacy: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', terms: 'http://www.amb.cat/web/mobilitat/autobus/busademanda/cervello', owner: null, someLanguages: false, selected: isAmb },
    { name: 'Iframe', privacy: `https://www.divertisenvivo.com/politica-privacidad-venta-online`, terms: `https://www.divertisenvivo.com/terminos-y-condiciones/`, owner: 'Divertis en vivo', someLanguages: false, selected: isIframe },
    { name: 'Beira Baixa', privacy: `http://www.nemi.mobi/app/legal/`, terms: `http://www.nemi.mobi/app/terms/`, owner: 'CIM Beira Baixa', someLanguages: false, selected: isBeiraBaixa },
]

const appsShowRefundsSection = [
    { name: 'Nemi', show: false, selected: isNemi },
    { name: 'AMB', show: false, selected: isAmb },
    { name: 'Iframe', show: false, selected: isIframe },
    { name: 'Beira Baixa', show: false, selected: isBeiraBaixa },
]

const appsLogin = [
    { name: 'Nemi', login: ['email'], selected: isNemi },
    { name: 'AMB', login: ['dni', 'email'], selected: isAmb },
    { name: 'Iframe', login: ['email'], selected: isIframe },
    { name: 'Beira Baixa', login: ['phone'], selected: isBeiraBaixa },
]

// Sign in screen layout. classic: the pre-redesign screen (logo, underlined title, credentials,
// forgotten password, button and sign up link) — no Google, guest mode nor verification code.
const appsSignInLayout = [
    { name: 'Nemi', classic: false, selected: isNemi },
    { name: 'AMB', classic: true, selected: isAmb },
    { name: 'Iframe', classic: false, selected: isIframe },
    { name: 'Beira Baixa', classic: false, selected: isBeiraBaixa },
]

const beiraBaixaSignInLanding: ISignInLanding = {
    heroImage: 'signInHeroBeiraBaixa',
    heroLogo: 'logoMobbiBeiraBaixaWhite',
    stores: [
        {
            store: 'googlePlay',
            url: 'https://play.google.com/store/apps/details?id=mobi.nemi.beirabaixa',
            qrCode: 'qrCodeGooglePlayBeiraBaixa',
            icon: 'iconGooglePlay'
        },
        {
            store: 'appStore',
            url: 'https://apps.apple.com/app/id6817294110',
            qrCode: 'qrCodeAppStoreBeiraBaixa',
            icon: 'iconApple'
        },
    ],
    frequentlyAskedQuestions: 9,
    contact: {
        organisation: 'Comunidade Intermunicipal da Beira Baixa',
        addressLines: [ 'Praça Rainha D. Leonor', 'Edifício dos Emblemas, 1º-2º andar', '6000-117 Castelo Branco' ],
        phone: '800 502 502',
        email: 'transportes@cimbeirabaixa.pt',
        website: 'https://flexivel.cimbeirabaixa.pt/',
    },
    partnerLogos: [
        { image: 'logoCimBeiraBaixa', altKey: 'logoCimBeiraBaixa' },
        { image: 'logoFundoDeTransportes', altKey: 'logoFundoDeTransportes' },
    ],
}

const appsSignInLanding = [
    { name: 'Nemi', landing: null as ISignInLanding | null, selected: isNemi },
    { name: 'AMB', landing: null as ISignInLanding | null, selected: isAmb },
    { name: 'Iframe', landing: null as ISignInLanding | null, selected: isIframe },
    { name: 'Beira Baixa', landing: beiraBaixaSignInLanding, selected: isBeiraBaixa },
]

const appsUsername = [
    { name: 'Nemi', username: 'email', selected: isNemi },
    { name: 'AMB', username: 'dni', selected: isAmb },
    { name: 'Iframe', username: 'email', selected: isIframe },
    { name: 'Beira Baixa', username: 'phone', selected: isBeiraBaixa },
]

const appsRecoverPassword = [
    { name: 'Nemi', username: 'email', selected: isNemi },
    { name: 'AMB', username: 'dni', selected: isAmb },
    { name: 'Iframe', username: 'email', selected: isIframe },
    { name: 'Beira Baixa', username: 'phone', selected: isBeiraBaixa },
]

// Extra sign-up fields to show, beyond name/lastName. 'dni' and 'email' are for brands that
// register by phone: AMB's Spanish DNI still comes from REACT_APP_SHOW_DNI, and email brands
// already ask for the email as their username.
const appsRegister = [
    { name: 'Nemi', data: [] as string[], selected: isNemi },
    { name: 'AMB', data: [] as string[], selected: isAmb },
    { name: 'Iframe', data: [] as string[], selected: isIframe },
    { name: 'Beira Baixa', data: [ 'dni', 'email' ], idNumber: 'nif', selected: isBeiraBaixa },
]

// Document upload requirement, mirrored from mobile's appsDocument config.
// Disabled (requireDocumentation: false) for every brand nemi-web currently
// serves — built ready but inactive, same pattern as the other Fase 2 items.
const appsDocument = [
    { name: 'Nemi', documentType: [DocumentType.ID_CARD, DocumentType.HEALTH_CARD], mandatory: true, selected: isNemi, requireDocumentation: false },
    { name: 'AMB', documentType: [DocumentType.ID_CARD, DocumentType.PASSPORT], mandatory: true, selected: isAmb, requireDocumentation: false },
    { name: 'Iframe', documentType: [DocumentType.ID_CARD, DocumentType.PASSPORT], mandatory: true, selected: isIframe, requireDocumentation: false },
    { name: 'Beira Baixa', documentType: [], mandatory: false, selected: isBeiraBaixa, requireDocumentation: false },
]

// Temporal passes (wallet), mirrored from mobile's appsTemporalPasses config.
// Disabled for every brand — mobile ships it disabled everywhere too, so the
// wallet is built ready but inactive until a brand opts in.
const appsTemporalPasses = [
    { name: 'Nemi', enabled: false, selected: isNemi },
    { name: 'AMB', enabled: false, selected: isAmb },
    { name: 'Iframe', enabled: false, selected: isIframe },
    { name: 'Beira Baixa', enabled: false, selected: isBeiraBaixa },
]

// Cancellation reason asked when deleting a booking. With `reasons` the modal offers a
// picker of those values; without it, a free text field. Mirrors the app, where every
// brand nemi-web serves goes without a list and without making it mandatory.
const appsCancelBookingReasons = [
    { name: 'Nemi', reasons: null as typeof ICancelBookingReasons | null, selected: isNemi },
    { name: 'AMB', reasons: null as typeof ICancelBookingReasons | null, selected: isAmb },
    { name: 'Iframe', reasons: null as typeof ICancelBookingReasons | null, selected: isIframe },
    { name: 'Beira Baixa', reasons: null as typeof ICancelBookingReasons | null, selected: isBeiraBaixa },
]

const appsMandatoryCancellationReason = [
    { name: 'Nemi', mandatory: false, selected: isNemi },
    { name: 'AMB', mandatory: false, selected: isAmb },
    { name: 'Iframe', mandatory: false, selected: isIframe },
    { name: 'Beira Baixa', mandatory: false, selected: isBeiraBaixa },
]

const appsHourMayUpdate = [
    { name: 'Nemi', showTime: true, selected: isNemi },
    { name: 'AMB', showTime: true, selected: isAmb },
    { name: 'Iframe', showTime: true, selected: isIframe },
    { name: 'Beira Baixa', showTime: false, selected: isBeiraBaixa },
]

// Penalties section: whether the brand shows it at all. The app has no config for this —
// it derives the tab from the brand (everyone but AMB) — so here it is explicit and
// independent of the wallet, which the app made share the same tab slot.
const appsPenalties = [
    { name: 'Nemi', enabled: false, selected: isNemi },
    { name: 'AMB', enabled: false, selected: isAmb },
    { name: 'Iframe', enabled: false, selected: isIframe },
    { name: 'Beira Baixa', enabled: false, selected: isBeiraBaixa },
]

// Scheduled (recurring) bookings, mirrored from mobile's appsScheduled config.
// Disabled for every brand — mobile ships it disabled everywhere too.
const appsScheduled = [
    { name: 'Nemi', scheduled: false, selected: isNemi },
    { name: 'AMB', scheduled: false, selected: isAmb },
    { name: 'Iframe', scheduled: false, selected: isIframe },
    { name: 'Beira Baixa', scheduled: false, selected: isBeiraBaixa },
]

// Suggestion shortcuts on the booking flow, mirrored from mobile's appsSuggestionsAlerts: a floating
// button on the stops map to suggest a stop, and one on the date step to suggest a timetable.
const appsSuggestionsAlerts = [
    { name: 'Nemi', suggestStop: false, suggestSchedule: false, selected: isNemi },
    { name: 'AMB', suggestStop: false, suggestSchedule: false, selected: isAmb },
    { name: 'Iframe', suggestStop: false, suggestSchedule: false, selected: isIframe },
    { name: 'Beira Baixa', suggestStop: false, suggestSchedule: false, selected: isBeiraBaixa },
]

// Country preselected in the phone inputs (sign in, sign up), mirrored from mobile's appsDefaultPhoneCountry.
const appsDefaultPhoneCountry = [
    { name: 'Nemi', countryCode: 'ES', selected: isNemi },
    { name: 'AMB', countryCode: 'ES', selected: isAmb },
    { name: 'Iframe', countryCode: 'ES', selected: isIframe },
    { name: 'Beira Baixa', countryCode: 'PT', selected: isBeiraBaixa },
]

// Browser Google sign-in (Google Identity Services): the WEB client id, whose audience the gateway
// validates. The origins the web is served from must be registered as Authorized JavaScript origins
// on that client in the Google Cloud console. A null client id leaves Google sign-in off.
const appsGoogle = [
    { name: 'Nemi', webClientId: '199162947909-6cvrhtnftdlmpa9o1en2hqb44j8tem17.apps.googleusercontent.com', selected: isNemi },
    { name: 'AMB', webClientId: null as string | null, selected: isAmb },
    { name: 'Iframe', webClientId: null as string | null, selected: isIframe },
    { name: 'Beira Baixa', webClientId: null as string | null, selected: isBeiraBaixa },
]

// showSelector: whether the user can change the language (selector on the auth screens and
// Configuration > Change language).
const appsLanguagePosition = [
    { name: 'Nemi', languages: [ 'en', 'es', 'ca', 'eu', 'pt', 'fr', 'de', 'it', 'nl', 'hu', 'si', 'hr', 'el' ], showSelector: true, selected: isNemi },
    { name: 'AMB', languages: [ 'ca', 'es', 'en' ], showSelector: false, selected: isAmb },
    { name: 'Iframe', languages: [ 'en', 'es', 'ca', 'eu', 'pt', 'fr', 'de', 'it', 'nl', 'hu', 'si', 'hr', 'el' ], showSelector: true, selected: isIframe },
    { name: 'Beira Baixa', languages: [ 'pt', 'en', 'es' ], showSelector: true, selected: isBeiraBaixa },
]

export const appsStyleSelected = appsStyle.find(app => app.selected)

export const appsGeneralInfoSelected = appsGeneralInfo.find(app => app.selected)

export const appsURLSSelected = appsURLS.find(app => app.selected)

export const appsLogosSelected = appsLogos.find(app => app.selected)

export const appsPrivacyAndTermsOptionsSelected = appsPrivacyAndTermsOptions.find(app => app.selected)

export const appsShowRefundsSectionSelected = appsShowRefundsSection.find(app => app.selected)

export const appsLanguagePositionSelected = appsLanguagePosition.find(app => app.selected)

export const defaultPhoneCountryCode = appsDefaultPhoneCountry.find(app => app.selected)?.countryCode ?? 'ES'

export const googleWebClientId = appsGoogle.find(app => app.selected)?.webClientId ?? ''

export const appsSuggestionsAlertsSelected =appsSuggestionsAlerts.find(app => app.selected)

export const appsLoginSelected = appsLogin.find(app => app.selected)

export const appsUsernameSelected = appsUsername.find(app => app.selected)

export const isClassicSignIn = !!appsSignInLayout.find(app => app.selected)?.classic

export const signInLandingSelected = appsSignInLanding.find(app => app.selected)?.landing ?? null

// Where Cognito delivers the sign up code: by SMS for brands that register by phone, by email otherwise.
export const verificationCodeSentKey = appsUsernameSelected?.username === 'phone'
    ? 'verificationCodeSentSms'
    : 'verificationCodeSentEmail'
export const willSendNewVerificationCodeKey = appsUsernameSelected?.username === 'phone'
    ? 'willSendNewVerificationCodeSms'
    : 'willSendNewVerificationCodeEmail'

export const appsRecoverPasswordSelected = appsRecoverPassword.find(app => app.selected)

export const appsRegisterSelected = appsRegister.find(app => app.selected)

// The Spanish DNI/NIE, with its letter check, is AMB's. Beira Baixa asks for the Portuguese NIF,
// with its check digit. Other brands asking for an ID number only require it to be filled in.
export const isSpanishDni = process.env.REACT_APP_SHOW_DNI === 'true'
export const isPortugueseNif = appsRegisterSelected?.idNumber === 'nif'
export const showDNI = isSpanishDni || !!appsRegisterSelected?.data.includes('dni')
export const idNumberLiteralKey = isPortugueseNif ? 'nif' : 'dni'
export const idNumberInvalidLiteralKey = isPortugueseNif ? 'nifInvalid' : 'dniInvalid'

export const appsDocumentSelected = appsDocument.find(app => app.selected)

export const appsTemporalPassesSelected = appsTemporalPasses.find(app => app.selected)

export const appsScheduledSelected = appsScheduled.find(app => app.selected)

export const appsPenaltiesSelected = appsPenalties.find(app => app.selected)

export const appsCancelBookingReasonsSelected = appsCancelBookingReasons.find(app => app.selected)

export const appsMandatoryCancellationReasonSelected = appsMandatoryCancellationReason.find(app => app.selected)

export const appsHourMayUpdateSelected = appsHourMayUpdate.find(app => app.selected)